import {
  getErrorsOfInput,
  hideErrorBelowField,
  resetErrors,
} from './fieldsValidation';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { notification } from 'antd';

export function getErrorMessage(error) {
  let errorMessage: string = 'Something went wrong!';
  try {
    if (typeof error?.response?.data === 'string') {
      errorMessage = error?.response?.data;
    } else if (error?.response?.data?.errors) {
      const { errors } = error.response.data;
      if (Array.isArray(errors)) {
        errorMessage = '';
        getFieldErrorMessage(errors);
      } else {
        [errorMessage] = Object.values(errors);
      }
    } else if (error?.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error?.response?.data?.error) {
      errorMessage = error.response.data.error;
    }
  } catch {}
  return errorMessage.toString();
}

export function showErrorMessage(errorMessage = 'Something went wrong!') {
  notification.error({
    message: errorMessage,
    icon: <CloseCircleOutlined style={{ color: '#FF0000' }} />,
    style: { fontSize: 16, color: '#21314D' },
  });
}
export function showSuccessMessage(successMessage = 'Successful!') {
  notification.success({
    message: successMessage,
    icon: <CheckCircleOutlined style={{ color: '#37517F' }} />,
    style: { fontSize: 16, color: '#21314D' },
  });
}

export function showInfoMessage(infoMessage: string, description?: string) {
  notification.info({
    message: infoMessage,
    description,
    icon: <InfoCircleOutlined style={{ color: '#37517F' }} />,
    style: { fontSize: 16, color: '#21314D' },
  });
}

export function showError(error) {
  showErrorMessage(getErrorMessage(error));
}

export function showSucess(success) {
  showSuccessMessage(success.data.message);
}

export function getFormErrors(errors) {
  return Object.values(errors).filter(error => {
    return Boolean(error);
  });
}

export function fakeErrorResponse(data) {
  return {
    response: {
      data,
    },
  };
}

function getFieldErrorMessage(errors) {
  resetErrors();
  try {
    errors.forEach((error: any) => {
      hideErrorBelowField(error.fieldName);
      getErrorsOfInput(
        error.fieldName,
        () => true,
        error.message,
        error.notActivated,
      );
    });
  } catch {}
}
